import React from 'react';

import RouteWithSubRoutes from './RouteWithSubRoutes';
const buildRoutes = (routes = [], isWithoutDealer = false) => {
  return (
    routes &&
    routes.map(route => {
      return (
        <RouteWithSubRoutes
          key={route.id}
          {...route}
          isWithoutDealer={isWithoutDealer}
        />
      );
    })
  );
};
export default buildRoutes;
